import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { Board } from "../Board";
import { RectangleWithRadius } from "../../utils/RectangleWithRadius";
import { DifficultySelectionContainer } from "./DifficultySelectionContainer";
import { ColorSelectionContainer } from "./ColorSelectionContainer";
import { BoardManagerAI } from "../BoardManagerAI";

export class StartLayer extends Phaser.Group {

    constructor(game: Phaser.Game) {

        super(game, null, "start-layer");
        
        const darkLayer: Phaser.Sprite = this.create(0, 0, this.game.cache.getBitmapData(GameConstants.DARK_BLUE_SQUARE));
        darkLayer.alpha = GameConstants.ALPHA_LAYERS;
        darkLayer.inputEnabled = true;
        darkLayer.events.onInputDown.add(this.onClickDarkLayer, this);
        darkLayer.scale.set(GameConstants.GAME_WIDTH / GameConstants.BITMAP_SIZE, GameConstants.GAME_HEIGHT / GameConstants.BITMAP_SIZE);

        const menuContainer = new Phaser.Group(this.game);
        menuContainer.scale.y = GameVars.scaleY;
        menuContainer.x = GameConstants.GAME_WIDTH / 2;
        menuContainer.y = Board.BOARD_PY - 50 * GameVars.scaleY;
        this.add(menuContainer);

        const w = 524;
        const h = 520;

        const rectangleWithRadius = new RectangleWithRadius(this.game, -w / 2, -h / 2, w, h, 6, "#1b2d3d", .85);
        menuContainer.add(rectangleWithRadius);
        
        const difficultySelectionContainer = new DifficultySelectionContainer(this.game);
        difficultySelectionContainer.y = -80;
        menuContainer.add(difficultySelectionContainer);
        
        const colorSelectionContainer = new ColorSelectionContainer(this.game);
        colorSelectionContainer.y = 38;
        menuContainer.add(colorSelectionContainer);

        const playButton = new Phaser.Button(this.game, 0, 180, "texture_atlas_2_" + GameVars.language, this.onClickPlayButton, this);
        playButton.setFrames("button_start_on.png", "button_start_off.png", "button_start_on.png");
        playButton.anchor.set(.5);
        playButton.forceOut = true;
        menuContainer.add(playButton);
    } 

    private onClickPlayButton(b: Phaser.Button): void {
        
        b.clearFrames();

        BoardManagerAI.startGame();
    }

    private onClickDarkLayer(): void {
        //
    }   
}
